import styled from 'styled-components';

export const NavigatorNumberLink = styled.a`
  text-decoration: underline;
`;
